import React, { FC, useState, useEffect } from 'react';
import i18n from 'i18n';
import { List, Icon, Checkbox } from 'semantic-ui-react';

interface NotificationSettingPopupItemProps {
  title: string;
  onChange?: (notificationTypes: string[]) => void;
  active?: boolean;
  notificationTypes?: string[];
  disabled?: boolean;
  showTypeLabels?: boolean;
}

export const NotificationSettingPopupItem: FC<NotificationSettingPopupItemProps> = ({
  title,
  onChange,
  active: propActive,
  notificationTypes: propNotificationTypes,
  disabled = false,
  showTypeLabels = false
}) => {
  const [active, setActive] = useState(!!propActive);
  const [notificationTypes, setNotificationTypes] = useState(propNotificationTypes || []);

  // IMPROVEMENT: Synchronize state with props
  useEffect(() => {
    setActive(!!propActive);
    setNotificationTypes(propNotificationTypes || []);
  }, [propActive, propNotificationTypes]);

  const handleNotificationTypeToggle = (notificationType: 'ToDo' | 'Email') => {
    if (disabled) return;

    let nextNotificationTypes: string[];
    if (notificationTypes.includes(notificationType)) {
      nextNotificationTypes = notificationTypes.filter(x => x !== notificationType);
    } else {
      nextNotificationTypes = [...notificationTypes, notificationType];
    }

    const nextActive = nextNotificationTypes.length > 0;
    setActive(nextActive);
    setNotificationTypes(nextNotificationTypes);
    onChange?.(nextNotificationTypes);
  };

  const handleMasterToggle = (checked: boolean) => {
    if (disabled) return;

    const nextNotificationTypes = checked ? ['ToDo', 'Email'] : [];
    setActive(checked);
    setNotificationTypes(nextNotificationTypes);
    onChange?.(nextNotificationTypes);
  };

  return (
    <List.Item className={`popup-item ${disabled ? 'disabled' : ''}`}>
      <List.Content floated="right">
        {showTypeLabels && (
          <div className="notification-type-labels">
            <span className="notification-type-label">In-App</span>
            <span className="notification-type-label">Email</span>
          </div>
        )}
        <Icon
          onClick={() => handleNotificationTypeToggle('ToDo')}
          name="bell"
          className={`popup-icon ${notificationTypes.includes('ToDo') ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
          title={i18n.t('In-App Notification')}
        />
        <Icon
          onClick={() => handleNotificationTypeToggle('Email')}
          name="mail"
          className={`popup-icon ${notificationTypes.includes('Email') ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
          title={i18n.t('Email Notification')}
        />
      </List.Content>
      <List.Content>
        <Checkbox
          checked={active}
          onChange={(_, { checked }) => handleMasterToggle(!!checked)}
          className="popup-chkbx"
          label={i18n.t(title)}
          disabled={disabled}
        />
      </List.Content>
    </List.Item>
  );
};
